import React, { useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Row, Typography, notification } from 'antd';
import { Path, useFormContext } from 'react-hook-form';

import { IFormValues } from 'pages/Resorts/interfaces';
import { pick } from 'utils/helpers';
import { mapDataToCompact } from 'pages/Resorts/utils';
import { EntitySelect } from 'components/form/AsyncSelect/EntitySelect';
import { urls } from 'store/api';

import styles from './RestaurantForm.module.less';
import { RestaurantTable } from './components/Table/RestaurantTable';

export const RestaurantForm = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<IFormValues>();

  const watchData = watch('restaurants');

  const handleAdd = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data } = watchData as any;
    const preparedToTableData = pick(data, 'id', 'name', 'image', 'address');
    const sortPriority = watchData.length + 1;
    const newData = { ...preparedToTableData, sortPriority };

    const restaurantExists = watchData.some(
      item => item.id === preparedToTableData.id
    );
    if (!restaurantExists) {
      setValue('restaurants', [...watchData, newData]);
    } else {
      notification.info({
        message: 'Уже добавлено!',
      });
    }
  };

  const handleRemove = (id: string | number) => {
    const updatedRestaurantData = watchData.filter(item => item.id !== id);
    setValue('restaurants', updatedRestaurantData);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSort = (item: Record<string, any>, direction: 'up' | 'down') => {
    const index = watchData.findIndex(col => col.id === item.id);

    if (direction === 'up' && index > 0) {
      const updatedData = [...watchData];
      const temp = updatedData[index];
      updatedData[index] = updatedData[index - 1];
      updatedData[index - 1] = temp;

      setValue(
        'restaurants',
        updatedData.map((attr, idx) => ({ ...attr, sortPriority: idx + 1 }))
      );
    } else if (direction === 'down' && index < watchData.length - 1) {
      const updatedData = [...watchData];
      const temp = updatedData[index];
      updatedData[index] = updatedData[index + 1];
      updatedData[index + 1] = temp;

      setValue(
        'restaurants',
        updatedData.map((attr, idx) => ({ ...attr, sortPriority: idx + 1 }))
      );
    }
  };

  const getActions = (item: { id: string | number }) => [
    {
      element: 'Удалить',
      handler: () => handleRemove(item.id),
    },
  ];

  const sortedRestaurantData = [...watchData].sort(
    (a, b) => a.sortPriority - b.sortPriority
  );

  useEffect(() => {
    setValue('restaurants', mapDataToCompact(watchData));
  }, [setValue]);

  return (
    <>
      {errors.restaurants ? (
        <Typography.Text type='danger' className={styles.errorText}>
          {errors.restaurants.message}
        </Typography.Text>
      ) : null}

      <Row gutter={[16, 16]}>
        <Col xl={10} md={12}>
          <EntitySelect
            name={`restaurants.data` as Path<IFormValues>}
            label=''
            placeholder=''
            additional={{
              lang: 'ru',
            }}
            required
            requestUrl={urls.api.restaurants.get}
          />

          <Button
            style={{ marginBottom: '15px' }}
            icon={<PlusOutlined />}
            onClick={handleAdd}
            disabled={watchData.length === 8}
          >
            Добавить
          </Button>
        </Col>
        <Col>
          <RestaurantTable
            handleSort={handleSort}
            data={sortedRestaurantData}
            getActions={getActions}
          />
        </Col>
      </Row>
    </>
  );
};
